export default __webpack_public_path__ + "static/media/expand-more.58e76d9f.svg";